module.exports = __webpack_public_path__ + "static/nerdmode-min-10b3eab073b9ac6a1ee27a224ef8544a.gif";